module.exports = __webpack_public_path__ + "media/images/close2-589e915b815cbdfc98db78a40b63287a.png";